import { render, staticRenderFns } from "./RateCampaigns.vue?vue&type=template&id=4a19f0e0&"
import script from "./RateCampaigns.vue?vue&type=script&lang=js&"
export * from "./RateCampaigns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports